/* Bundle builder — quantity tiers with per-item variant pickers.

   IMPORTANT — how the discount actually happens.
   A theme cannot create a discount. The percentages shown on the tiers are
   display only. Something has to make them real, and there are exactly two
   supported ways:

     1. Automatic discount in Shopify admin (Discounts > Automatic, "minimum
        quantity of N"). Nothing to configure here; just make the numbers match.
     2. A discount code per tier, entered in the theme editor. This file then
        applies it to the cart via /discount/<code> when the tier is chosen.

   If neither is set up the shopper is shown a saving she will not receive at
   checkout, so applyTierCode() below also warns in the console during design
   mode to make that impossible to miss. */
(function () {
  function init(root) {
    if (root.dataset.bundleReady === 'true') return;
    root.dataset.bundleReady = 'true';

    var tiers = root.querySelectorAll('[data-bundle-tier]');
    var itemsWrap = root.querySelector('[data-bundle-items]');
    var items = root.querySelectorAll('[data-bundle-item]');
    if (!tiers.length) return;

    function select(qty) {
      tiers.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.dataset.bundleTier, 10) === qty);
      });

      var anyVisible = false;
      items.forEach(function (item) {
        var show = parseInt(item.dataset.bundleItem, 10) <= qty;
        item.hidden = !show;
        if (show) anyVisible = true;
      });
      if (itemsWrap) itemsWrap.hidden = !anyVisible;

      root.dataset.bundleQty = String(qty);

      // Keep the product form's quantity in sync so add-to-cart adds the bundle.
      var form = root.closest('form[action*="/cart/add"]') ||
                 document.querySelector('form[action*="/cart/add"]');
      if (form) {
        var qtyInput = form.querySelector('input[name="quantity"]');
        if (!qtyInput) {
          qtyInput = document.createElement('input');
          qtyInput.type = 'hidden';
          qtyInput.name = 'quantity';
          form.appendChild(qtyInput);
        }
        qtyInput.value = String(qty);
        syncProperties(form, qty);
      }

      applyTierCode(root.querySelector('[data-bundle-tier].is-active'));

      root.dispatchEvent(new CustomEvent('bundle:change', {
        bubbles: true,
        detail: { quantity: qty, discount: activeDiscount() }
      }));
    }

    // Applying a code is a real network call, so only do it when the tier
    // genuinely changed — otherwise every re-render re-hits /discount.
    var lastAppliedCode = null;
    function applyTierCode(tier) {
      var code = tier && tier.dataset.bundleCode;
      if (!code) {
        if (window.Shopify && window.Shopify.designMode && parseInt(tier.dataset.bundleDiscount, 10) > 0) {
          console.warn(
            '[bundle] Tier "' + tier.dataset.bundleTier + '" shows -' +
            tier.dataset.bundleDiscount + '% but has no discount code, and no ' +
            'automatic discount can be verified from the theme. Set a code in ' +
            'the block settings, or create a matching automatic discount in ' +
            'Shopify admin, or the shopper pays full price.'
          );
        }
        return;
      }
      if (code === lastAppliedCode) return;
      lastAppliedCode = code;
      // /discount/<code> sets the cart discount and 204s with no redirect.
      fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin' })
        .catch(function () { lastAppliedCode = null; });
    }

    function activeDiscount() {
      var active = root.querySelector('[data-bundle-tier].is-active');
      return active ? parseInt(active.dataset.bundleDiscount, 10) || 0 : 0;
    }

    // Mirror each visible item's selects into hidden line-item properties.
    function syncProperties(form, qty) {
      form.querySelectorAll('[data-bundle-prop]').forEach(function (el) { el.remove(); });
      items.forEach(function (item) {
        var n = parseInt(item.dataset.bundleItem, 10);
        if (n > qty) return;
        item.querySelectorAll('select').forEach(function (sel) {
          var match = sel.name.match(/\[([^\]]+)\]\s*$/);
          var optionName = match ? match[1] : 'Option';
          var input = document.createElement('input');
          input.type = 'hidden';
          input.setAttribute('data-bundle-prop', '');
          input.name = 'properties[Item ' + n + ' — ' + optionName + ']';
          input.value = sel.value;
          form.appendChild(input);
        });
      });
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        select(parseInt(t.dataset.bundleTier, 10));
      });
    });

    root.addEventListener('change', function (e) {
      if (e.target && e.target.matches('select')) {
        var form = root.closest('form[action*="/cart/add"]') ||
                   document.querySelector('form[action*="/cart/add"]');
        if (form) syncProperties(form, parseInt(root.dataset.bundleQty || '1', 10));
      }
    });

    select(1);
  }

  function boot() {
    document.querySelectorAll('[data-bundle-builder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
